import {Button} from 'antd';
import React, {FC, useState} from 'react';

import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';
import {tableReportSliceActions} from 'store/slices/table-report-slice';
import {loadTableReportPageData} from 'store/slices/table-report-slice/table-report-slice-thunks';

import {ControlRatiosModal} from './modals/control-ratios-modal';

const {
    updateComparisonOptions,
} = tableReportSliceActions;
interface IControlRatiosActionsButtonsProps {
    docId: string;
}

export const ControlRatiosActionsButtons: FC<IControlRatiosActionsButtonsProps> = ({
    docId,
}: IControlRatiosActionsButtonsProps) => {
    const dispatch = useAppDispatch();
    const [showCancelButton, setShowCancelButton] = useState(false);

    const isTableReportLoading = useAppSelector(state => selectIsThunkPending(
        state,
        loadTableReportPageData.typePrefix,
    ));

    const handleCancel = () => {
        dispatch(updateComparisonOptions({
            includeControlRatioBySettings: false,
            noFetchWithCustomCR: true,
            noFetchWithCR: true,
            noFetchWithComparison: true,
        }));

        setShowCancelButton(false);
    };

    return (
        <>
            <ControlRatiosModal
                docId={docId}
                disabled={isTableReportLoading || showCancelButton}
                setShowCancelButton={setShowCancelButton}
            />

            {showCancelButton && (
                <Button
                    type="default"
                    disabled={isTableReportLoading}
                    onClick={handleCancel}
                >
                    Скрыть контрольные соотношения
                </Button>
            )}
        </>
    );
};
